import premioElbb from 'assets/img/2026/elbb.png';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoriasParticipantes.scss';

export interface CategoriaItem {
  id: string;
  nome: string;
  imagem: string;
}

// Em ELBB a votação da Etapa 3 não separa por perspectiva — todas as iniciativas
// com categoryPremio === 'ELBB' são listadas em um único bucket.
export const CATEGORIAS_PARTICIPANTES_ETAPA3: CategoriaItem[] = [
  { id: 'ELBB', nome: 'Prêmio ELBB', imagem: premioElbb },
];

const IDS_ETAPA3_ELBB = new Set(CATEGORIAS_PARTICIPANTES_ETAPA3.map((c) => c.id));

/**
 * Verifica se um voto preliminar (voto_preliminar_etapa3__c) pertence ao produto
 * ELBB. A collection é compartilhada com a Conexão — um preliminar é ELBB quando
 * suas notasRascunho contêm ao menos uma categoria da Etapa 3 do ELBB.
 */
export const isPreliminarElbb = (
  notasRascunho?: Record<string, unknown> | null
): boolean =>
  !!notasRascunho &&
  Object.keys(notasRascunho).some((cat) => IDS_ETAPA3_ELBB.has(cat));

interface CategoriasParticipantesEtapa3Props {
  title?: string;
  categoriaSelecionada?: string;
  onCategoriaChange?: (categoria: string) => void;
  contadores?: Record<string, number>;
  limitePorCategoria?: number;
}

export const CategoriasParticipantesEtapa3: React.FC<CategoriasParticipantesEtapa3Props> = ({
  title,
  categoriaSelecionada,
  onCategoriaChange,
  contadores,
  limitePorCategoria,
}) => {
  const navigate = useNavigate();

  const handleClick = (categoriaId: string) => {
    if (onCategoriaChange) {
      onCategoriaChange(categoriaId);
    } else {
      navigate('/votacao-etapa-3', { state: { categoria: categoriaId } });
    }
  };

  return (
    <div className="categorias-participantes">
      {title && <h2 className="categorias-participantes__title">{title}</h2>}
      {!title && (
        <h2 className="categorias-participantes__title">Categorias da Etapa 3</h2>
      )}
      <div className="categorias-participantes__grid">
        {CATEGORIAS_PARTICIPANTES_ETAPA3.map((categoria) => {
          const count = contadores?.[categoria.id] ?? 0;
          const limite = limitePorCategoria ?? 0;
          const isSelected = categoriaSelecionada === categoria.id;
          const isComplete = limite > 0 && count >= limite;

          return (
            <button
              key={categoria.id}
              type="button"
              className={`categorias-participantes__btn${isSelected ? ' is-selected' : ''}${isComplete ? ' is-complete' : ''}`}
              onClick={() => handleClick(categoria.id)}
              aria-label={`${categoria.nome}${contadores ? ` — ${count}/${limite} votos` : ''}`}
              aria-pressed={isSelected}
            >
              <img src={categoria.imagem} alt="" aria-hidden="true" />
              <span className="categorias-participantes__nome">{categoria.nome}</span>
              {contadores && limite > 0 && (
                <span className="categorias-participantes__counter" aria-hidden="true">
                  {count}/{limite}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
